import { Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

/** An SRB code, as a link to the shipments page */
export function SrbCode({ code }: { code: string }) {
  return (
    <Link
      component={RouterLink}
      to={`/shipments/${code}`}
      underline="hover"
      sx={{ fontWeight: 600, whiteSpace: 'nowrap' }}
    >
      {code}
    </Link>
  );
}
